import { Quote, Shell, CustomerArea, Offline } from './scenes';
import * as React from 'react';
import steps from './scenes/Quote/steps';
import { IBrandingState } from './services/branding/models';
import { ICustomer } from './data/api/models';
import { Route, Switch } from 'react-router';

import Contacts from './scenes/Brochure/scenes/Contacts';
import WhoWeAre from './scenes/Brochure/scenes/WhoWeAre';
import UsefulLinks from './scenes/Brochure/scenes/UsefulLinks';
import Faq from './scenes/Brochure/scenes/Faq';
import LegalNotice from './scenes/Brochure/scenes/LegalNotice';
import GeneralConditions from './scenes/Brochure/scenes/GeneralConditions';

interface IAppProps {
  branding: IBrandingState;
  customer?: ICustomer;
}

export default ({ branding, customer }: IAppProps) => {
  const quoteSteps = steps(branding.channel);
  const customerArea = <CustomerArea key={1} steps={quoteSteps} channel={branding.channel} />;
  const quote = <Quote key={2} steps={quoteSteps} channel={branding.channel} customer={customer} />;
  const pageTitles = {
    '/contacts': 'Contacts',
    '/who-we-are': 'Qui sommes-nous?',
    '/useful-links': 'Lien utiles',
    '/faq': 'Foire Aux Questions',
    '/legal-notice': 'Mentions légales et CGU',
    '/general-conditions': 'Conditions Generales d\'utilisation du site',
    '/auth/login': 'Connexion client',
    '/auth/remind': 'Mot de passe oublié',
    '/auth/create-an-account': 'Créer votre espace personnel',
  };
  const routes = (
    <Switch>
      <Route exact={true} path="/contacts" component={Contacts} />
      <Route exact={true} path="/who-we-are" component={WhoWeAre} />
      <Route exact={true} path="/useful-links" component={UsefulLinks} />
      <Route exact={true} path="/faq" component={Faq} />
      <Route exact={true} path="/legal-notice" component={LegalNotice} />
      <Route exact={true} path="/general-conditions" component={GeneralConditions} />

      <Route path="/auth">{customerArea}</Route>
      <Route path="/account">{customerArea}</Route>
      <Route path="/password">{customerArea}</Route>
      <Route>{quote}</Route>
    </Switch>
  );

  return (
    <Shell pageTitles={pageTitles} steps={quoteSteps} channel={branding.channel}>
      {branding.isOffline ? <Offline /> : routes}
    </Shell>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/index.tsx